export class TplArbetsorderListModel {
    header: ITplArbetsorderListHeader[];
    rows: ITplArbetsorderListRow[];
    detailsHeader: ITplArbetsorderListDetailsHeader[];

    constructor(header: ITplArbetsorderListHeader[],
        rows: ITplArbetsorderListRow[],
        detailsHeader: ITplArbetsorderListDetailsHeader[]) {
        this.header = header;
        this.rows = rows;
        this.detailsHeader = detailsHeader;
    }
}

export interface ITplArbetsorderListHeader {
    title: string;
    width: string;
}

export interface ITplArbetsorderListDetailsHeader {
    title: string;
    width: string;
    hasBorder: boolean;
}

export interface ITplArbetsorderListRow {
    handelssortimentId: number;
    isDetailsOpen: boolean;
    columns: ITplArbetsorderListColumn[];
    detailsRow: ITplArbetsorderListDetailsRow;
}

export interface ITplArbetsorderListDetailsRow {
    columns: ITplArbetsorderListColumn[];
}

export interface ITplArbetsorderListColumn {
    content: any;
    typ: TplArbetsorderListColumnType;
    width: string;
}

export enum TplArbetsorderListColumnType {
    text,
    list,
    nameList,
    distance
}
